import { useState, useEffect } from "react";
import {
    DataGridPremium
} from "@mui/x-data-grid-premium";
import { useNavigate } from "react-router";
import classes from "../../Redeem.module.css";
import { toast } from "react-toastify";
import Loader from "../../../../components/Loader/Loader";
import AUTH_CONTEXT from "../../../../store";
import { BASE_PATH_TO_ADD_SUBSCRIPTIONS, BASE_PATH_TO_UPDATE_SUBSCRIPTIONS } from "../../../../base_routes_paths/redeem_paths";
import CustomToolbar from "../../../../components/toolbar";
import { BASE_PATH_TO_HOME } from "../../../../base_routes_paths/data_paths";
import { Breadcrumbs, Link, Typography } from "@mui/material";
import { SubscriptionsServices } from "../../../../services/redeem_services";

const SubscriptionsList = () => {
    const userColumns = [
        { field: "Name", headerName: "Name", width: 120 },
        {
            field: "Price",
            headerName: "Price",
            width: 60,
        },
        {
            field: "Duration",
            headerName: "Duration",
            width: 80,
        },
        {
            field: "AndroidproductId",
            headerName: "Android Product Id",
            width: 150,
        },
        {
            field: "IOSproductId",
            headerName: "IOS Product Id",
            width: 180,
        },
        {
            field: "IsActive",
            headerName: "IsActive",
            width: 100,
        },
        {
            field: "IsAdsFree",
            headerName: "IsAdsFree",
            width: 100,
        },
        {
            field: "IsReminders",
            headerName: "IsReminders",
            width: 100,
        },
    ];

    const { token, fileName } = AUTH_CONTEXT()
    const EXPORT_FILENAME = `${fileName}_VouchersList`;

    const [isDataFetched, setIsDataFetched] = useState(false);
    const [data, setData] = useState([]);
    const navigate = useNavigate()

    const FetchApi = async () => {
        try {
            let response = await SubscriptionsServices.getAllSubscriptions(token, navigate, null);

            if (response.status === 207) {
                return toast
                    .error(response.error, {
                        position: "bottom-left",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: false,
                        draggable: false,
                        progress: undefined,
                        theme: "light",
                    })
            }
            setIsDataFetched(true);

            let result = response.data;

            let input = result.map(({ _id: id, ...result }) => ({
                id,
                ...result,
            }));
            setData(input);
            toast.success("Data fetched successfully!!", {
                position: "bottom-left",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        } catch (e) {
            setIsDataFetched(false);
            toast.error(e, {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        }
    };

    useEffect(() => {
        if (!isDataFetched) {
            FetchApi();
        }
    }, []);

    const handleDelete = (id) => {
        SubscriptionsServices.deleteSubscription(id, token);
    };

    const actionColumn = [
        {
            field: "action",
            headerName: "Action",
            width: 200,
            renderCell: (params) => {
                return (
                    <div className={classes.cellAction}>
                        <a target="_blank" rel="noreferrer" href={`${BASE_PATH_TO_UPDATE_SUBSCRIPTIONS}/` + params.row.id}
                            style={{ textDecoration: "none" }}
                        >
                            <div className={classes.viewButton}>Update</div>
                        </a>
                        <div
                            className={classes.deleteButton}
                            onClick={() => handleDelete(params.row.id)}
                        >
                            Delete
                        </div>
                    </div>
                );
            },
        },
    ];

    return (
        <div>
            {isDataFetched && (
                <div className={classes.datatable}>
                    <Breadcrumbs aria-label="breadcrumb" sx={{ marginBottom: 1 }}>
                        <Link underline="hover" color="inherit" href={BASE_PATH_TO_HOME}>
                            Dashboard
                        </Link>
                        <Typography color="text.primary">
                            Redeem
                        </Typography>
                        <Typography color="text.primary">SubscriptionsList</Typography>
                    </Breadcrumbs>
                    <DataGridPremium
                        rows={data}
                        columns={userColumns.concat(actionColumn)}
                        slots={{
                            toolbar: () => (
                                <CustomToolbar
                                    EXPORT_FILENAME={EXPORT_FILENAME}
                                    onClickCreate={() => {
                                        navigate(BASE_PATH_TO_ADD_SUBSCRIPTIONS);
                                    }}
                                    displayCreate={""}
                                    onClickUpdate={() => { }}
                                    displayUpdate={"none"}
                                />
                            ),
                        }}
                        pagination
                        initialState={{
                            pagination: {
                                paginationModel: { pageSize: 25, page: 0 },
                            },
                        }}
                        disableRowSelectionOnClick
                        checkboxSelection
                    />
                </div>
            )}
            {!isDataFetched && <Loader />}
        </div>
    );
};

export default SubscriptionsList;
